// Shared by the single-item and bulk placement/move dialogs so a quantity typed directly into
// either one is judged by the same rule: a whole number, at least 1, capped at what is available.
export const isValidQuantity = (quantity: number, max: number): boolean =>
  Number.isInteger(quantity) && quantity >= 1 && quantity <= max;
